import { useRef } from "react";
import { model_prospect } from "../../../../models";
import { ViewMetricas } from "../../../Commons/ViewMetricas";
import { Pessoa } from "../Pessoa";
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import { ObservacaoCliente } from "./Observacao";
import { NotebookPen } from "lucide-react";

export const Cliente = () => {
    const refviewmetricas = useRef<any>(null);
    const refobscliente = useRef<any>(null)

    const model_cliente = {
        ...model_prospect,
        name: 'Cliente',
        api_get: '/controlesProspeccao?situacao=5',
        api_post: undefined,
        api_delete: '/prospect',
        base: undefined
    };

    function functions(row: any) {
        return ([
            {
                label: 'Visualizar Métricas',
                click: () => refviewmetricas.current.openModal(row),
                icon: <QueryStatsIcon />,
                color: '#511688'
            },
            {
                label: 'Observações',
                click: () => { refobscliente.current.openModal(row.empresa.empid, row.prospid) },
                icon: <NotebookPen />,
                color: '#0589a0'
            }
        ])
    }


    return (
        <>
            <Pessoa model={model_cliente} table_functions={functions} />
            <ViewMetricas ref={refviewmetricas} />
            <ObservacaoCliente ref={refobscliente} />
        </>
    )
}